import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import CircledIcon from '../../../components/CircledIcon';
import { Container, Row, Col } from 'react-bootstrap';

export type HealthAndInsuranceOptionsType = {
  title: string;
  subTitles: string[];
}[];

const healthAndInsuranceOptions: HealthAndInsuranceOptionsType = [
  {
    title: 'Health Savings & Spending Accounts',
    subTitles: [
      'DCFSA Overview and FAQs',
      'HSA Investing Basics and FAQs',
      'LPHCFSA Overview and FAQs',
      'HCFSA Overview and FAQs',
      'HSA Patriotic Act FAQs',
      'Medicare and Your HSA and FAQs',
    ],
  },

  {
    title: 'Teladoc Medical Experts',
    subTitles: [
      'What is Teladoc Medical Experts?',
      'When should I use the Teladoc Medical Experts service?',
      'How do I request an Expert Medical Opinion with Teladoc Medical Experts?',
      'If I use Teladoc Medical Experts services, does that mean Teladoc is now my treating physician?',
    ],
  },
];

export type FAQsHealthAndInsuranceModalProps = {
  showFAQsHealthAndInsuranceModal: boolean;
  handleCloseFAQsHealthAndInsuranceModal: () => void;
};

function FAQsHealthAndInsuranceModal({
  showFAQsHealthAndInsuranceModal,
  handleCloseFAQsHealthAndInsuranceModal,
}: FAQsHealthAndInsuranceModalProps) {
  return (
    <>
      <Modal
        show={showFAQsHealthAndInsuranceModal}
        onHide={handleCloseFAQsHealthAndInsuranceModal}
        dialogClassName="modal-xl"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <Modal.Header closeButton className={'modal-header no-border'}>
          <Modal.Title className={'text-sm-20-lg-24'}>
            <span className={'d-none d-lg-inline-flex me-6'}>
              <CircledIcon icon={light('comments-question-check')} variant={'icon-emphasized'}/>
            </span>
            Health & Insurance
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container className={'p-0'}>
            {healthAndInsuranceOptions.map(({ title, subTitles }, index) => {
              return (
                <Row key={index} className={'mb-13'}>
                  <Col>
                    <h6
                      className={
                        'mb-0 pb-4 border-bottom border-info text-primary text-fs-base fw-light'
                      }
                    >
                      {title}
                    </h6>
                  </Col>
                  <Col
                    className={`col-12 ${
                      title !== healthAndInsuranceOptions[1].title
                        ? 'mc-layout-2-col'
                        : ''
                    }`}
                  >
                    {subTitles.map((option, index) => {
                      return (
                        <div
                          className={
                            'd-flex mb-0 py-6 text-fs-6 border-bottom border-info fw-light'
                          }
                          key={index}
                        >
                          {option}
                        </div>
                      );
                    })}
                  </Col>
                </Row>
              );
            })}
          </Container>
        </Modal.Body>
        <Modal.Footer className={'pt-0'}>
          <Button
            variant="primary-outline"
            size="lg"
            onMouseDown={handleCloseFAQsHealthAndInsuranceModal}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default FAQsHealthAndInsuranceModal;
